import React, { Component } from 'react'
import moment from 'moment';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

class AutofacturacionTicketsSearch extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { from: asFrom, to: asTo } = this.props;

    const from = !!asFrom ? moment(asFrom): moment().subtract(7, 'days');
    const to =  !!asTo ? moment(asTo) : moment();

    this.state = {
      date: [
        from.toDate(),
        to.toDate()
      ]
    }
  }

  handleOnKeywordChange = (keyword) => {
    this.handleOnSearch(keyword, this.state.index);
  }

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  }

  handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.onDateChange({
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD')
    });

    this.setState({ date });
  }

  getOmnisearchLegend = () => {
    const { index } = this.state;

    let legend = 'Omnisearch';

    switch (index) {
        case 'cfdi_uuid':
          legend = 'Folio Fiscal';
          break;
        case 'codigo':
          legend = 'Codigo';
          break;
        case 'sucursal':
          legend = 'Sucursal';
          break;
        case 'emisor_rfc':
          legend = 'Emisor RFC';
          break;
        case 'receptor_rfc':
          legend = 'Receptor RFC';
          break;
        case 'receptor_razon_social':
          legend = 'Receptor Nombre';
          break;
      default:
        break;
    }

    return legend;
  }

  handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    this.setState({
      index: id
    });

    const { search } = this.props;

    if (!!search) {
      this.handleOnSearch(search, id)
    }
  }

  handleOnSearch = (keyword, field) => {
    this.props.onKeywordChange({
      keyword,
      field
    });
  }

  render() {
    const { date } = this.state;
    const { search = '' } = this.props;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={ date }
            onDateChange={ this.handleOnDateChange }
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={ this.handleOnKeywordChange }
            onClear={ this.handleOnSearchClear }
            value={ search }
          >
            <DropdownButton
              variant="outline-secondary"
              title={ this.getOmnisearchLegend() }
              id="search-index"
              onSelect={ this.handleOnSelectIndex }
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item id="cfdi_uuid">Folio Fiscal</Dropdown.Item>
              <Dropdown.Item id="codigo">Código</Dropdown.Item>
              <Dropdown.Item id="sucursal">Sucursal</Dropdown.Item>
              <Dropdown.Item id="emisor_rfc">Emisor RFC</Dropdown.Item>
              <Dropdown.Item id="receptor_rfc">Receptor RFC</Dropdown.Item>
              <Dropdown.Item id="receptor_razon_social">Receptor Nombre</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    )
  }
}

export default AutofacturacionTicketsSearch;